<template>
  <div></div>
</template>

<script lang="ts">
import { inject } from 'vue';
import { useRouter } from '@/plugins/router';
import AccountService from '@/sections/account/service/account.service';
import { OtpAuthenticationRequest } from '@/sections/account/service/account.model';
import localStorageFacade, { StorageKey } from '@/shared/local-store-facade/LocalStoreFacade';
import { usePosthog } from '@/plugins/posthog';
import { logout } from '@/shared/security/security';
import AuthToken from '@/shared/security/AuthToken';
import UrlKeyHandler from './urlKeyHandler.model';
export default {
  name: 'OtpLogin',
  async created() {
    const accountService: () => AccountService = inject('accountService');
    const router = useRouter();
    const posthog = usePosthog();

    let key = router.currentRoute.query['key'];
    if (Array.isArray(key)) {
      key = key[0];
    }
    let urlKeyHandler;
    try {
      urlKeyHandler = UrlKeyHandler.fromEncodedKey(key as string);
    } catch (e) {
      // Errores de formato de key: reintentar login
      const nextUrl = router.currentRoute.query['next'];
      if (nextUrl && typeof nextUrl === 'string' && nextUrl !== '') {
        router.push({ name: 'login', query: { next: nextUrl } });
      } else {
        router.push({ name: 'login' });
      }
      return;
    }

    const otpAuthenticationRequest: OtpAuthenticationRequest = {
      otp: urlKeyHandler.getEncodedOtp(),
      username: urlKeyHandler.getUsername(),
      nextUrl: urlKeyHandler.getNextUrl()
    };
    let res;
    try {
      res = await accountService().otpAuthentication(otpAuthenticationRequest);
    } catch (err) {
      // Error grave inesperado (por ejemplo, fallo de red, backend, etc.)
      router.push({ name: 'Forbidden' });
      return;
    }

    if (res.error) {
      // Errores de OTP: reintentar login
      const nextUrl = router.currentRoute.query['next'];
      if (nextUrl && typeof nextUrl === 'string' && nextUrl !== '') {
        router.push({ name: 'login', query: { next: nextUrl } });
      } else {
        router.push({ name: 'login' });
      }
      return;
    }
    logout();
    sessionStorage.setItem('loginName', urlKeyHandler.getUsername());
    localStorageFacade.set(StorageKey.AUTH_TOKEN, res.jwt);
    localStorageFacade.set(StorageKey.AUTH_TOKEN_ISSUED_AT, Math.floor(Date.now() / 1000));

    const tokenPayload = AuthToken.decodeJWT(res.jwt);
    posthog.identify(tokenPayload.id, { username: tokenPayload.sub });

    // Redirigir a la URL indicada en el parámetro 'next' si existe, si no a Home
    const nextUrl = router.currentRoute.query['next'];
    if (nextUrl && typeof nextUrl === 'string' && nextUrl !== '') {
      router.push(nextUrl).catch(() => {});
    } else {
      router.push('/').catch(() => {});
    }
  }
};
</script>
